export const PIPEFITTER_REPORT_TYPES = {
  SEQUENCE: 'SEQUENCE',
  PIPE_DATA: 'PIPE_DATA',
  PIPE_COMPATIBILITY: 'PIPE_COMPATIBILITY',
} as const;

export type PipefitterReportType =
  (typeof PIPEFITTER_REPORT_TYPES)[keyof typeof PIPEFITTER_REPORT_TYPES];

export function isPipefitterReportType(value: unknown): value is PipefitterReportType {
  if (typeof value !== 'string') return false;
  return Object.values(PIPEFITTER_REPORT_TYPES).includes(value as PipefitterReportType);
}
